import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import { ResourceManagementEndpoints } from "@dmms/shared/data-access/resource-management/types/resource-management-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormComponentParams,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
  IHardTable,
} from "@hardcode-kz/ui";

import { EquipmentSelectionWithFilterComponent } from "../../components/equipment-selection-with-filter/equipment-selection-with-filter.component";
import {
  IEquipmentBookingAuthorizationPayload,
  IEquipmentBookingAuthorizationResponse,
} from "@dmms/shared/data-access/resource-management/models/equipment";

export class EquipmentBookingAuthorizationConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.EquipmentBookingAuthorization;

  isCrudByModal = true;
  modalSize = { width: "700px" };
  updateMethod: "POST" | "PUT" | "PATCH" = "POST";

  filterTemplateColumns = "1fr";

  fields: IHardFormField[] = [
    {
      title: "dicTable.user",
      name: "user",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType:
          "api/v1/" +
          ResourceManagementEndpoints.EquipmentBookingAuthorizationUsersWithoutAuthorization,
        fieldNames: ["fullName"],
        subNames: ["email"],
      } as IHardFormSelectParams,
    },
    {
      title: "dicTable.equipments",
      name: "equipments",
      type: HardFormFieldTypeEnum.Component,
      params: {
        component: EquipmentSelectionWithFilterComponent,
      } as IHardFormComponentParams,
    },
  ];

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: IHardTable<IEquipmentBookingAuthorizationResponse[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(3,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.fullName",
        name: "fullName",
        subName: "email",
        type: HardTableColumnTypeEnum.Parent,
        parent: "user",
      },
      {
        title: "dicTable.equipmentCount",
        name: "equipmentCount",
        type: HardTableColumnTypeEnum.Number,
      },
    ],

    dataCallback: this.dataCallback,
  };

  saveCallback(
    data: IEquipmentBookingAuthorizationPayload,
  ): IEquipmentBookingAuthorizationPayload {
    return {
      userId: data?.user?.id,
      equipmentIds: data?.equipments?.map((item) => item.id),
    };
  }

  dataCallback(
    data: IEquipmentBookingAuthorizationResponse[],
  ): IEquipmentBookingAuthorizationResponse[] {
    return data?.map((item) => ({
      ...item,
      id: item?.user?.id,
    }));
  }
}
